import { useHeaderLinks } from '../../_hooks'
import AHamburgerButton from '../a-hamburger-button'

import AHeaderDesktopLinks from './a-header-desktop-links'

export default function ADesktopHeaderMain({
	onMenuToggle,
	onLinkClick
}: {
	onMenuToggle: () => void
	onLinkClick: () => void
}) {
	const { secondaryLinks } = useHeaderLinks()

	return (
		<div className='desktop-header__main'>
			<div className='desktop-header__main-content'>
				<AHeaderDesktopLinks links={secondaryLinks} onLinkClick={onLinkClick} />

				<AHamburgerButton onMenuToggle={onMenuToggle} />
			</div>
		</div>
	)
}
